import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DynamicTitle from './components/DynamicTitle';
import Error from './pages/Error';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import PartnerTerms from "./pages/PartnerTerms";

function App() {
    return (
        <>
            <DynamicTitle />
            <div className="body_wrapper">
                <Header />
                <ScrollToTop />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/cookie-policy" element={<Cookies />} />
                    <Route path="/terms-and-conditions" element={<Terms />} />
                    <Route path="/partner-terms" element={<PartnerTerms />} />
                    <Route path="*" element={<Error />} />
                    {/* Rotta di fallback per gestire le pagine non trovate */}
                </Routes>
                <Footer />
            </div>
            <a id="back-to-top" title="Back to Top"></a>
        </>
    );
}

export default App;
